module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkAQMAAABKLAcXAAAABlBMVEVHcEzX19fBIrNLAAAAAXRSTlMAQObYZgAAAEpJREFUOMtjOG/zGY4uMDQwIIAAAwMeXgMKHzdPYNRMss1MwMITQOMx4OHhNmUIm8n+Hwj+wExB5Q13v5Nk5mg+GlxmfkYqaj8AADeiTu+WqoAuAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/addImg.png
// module id = 1566
// module chunks = 2